import { useMemo } from 'react';
import FusionEventCard from './FusionEventCard';
import { Event } from '@benzinga/events-manager';
import { FusionSectionGrid } from '../FusionSection';

export interface FusionEventsCalendarProps {
  events: Event[];
  maxCardsCount: number;
  withScroll: boolean;
  columns: {
    lg: number;
    md: number;
    sm?: number;
    xs?: number;
  };
}

const FusionEventsCalendar = ({ columns, events, maxCardsCount, withScroll }: FusionEventsCalendarProps) => {
  const eventsList = useMemo(() => (events ?? []).slice(0, maxCardsCount), [events, maxCardsCount]);
  return (
    <FusionSectionGrid columns={columns} mobileScroll={withScroll}>
      {eventsList.map((event, i) => (
        <FusionEventCard event={event} key={i} />
      ))}
    </FusionSectionGrid>
  );
};

FusionEventsCalendar.defaultProps = {
  columns: {
    lg: 3,
    md: 2,
    sm: 2,
    xs: 1,
  },
  maxCardsCount: 6,
  withScroll: true,
};

export default FusionEventsCalendar;
